import React from 'react';
import { ComponentsProvider } from '@advisorycloud/react-ui-components';

function EmptyLayout({ children, theme }) {
  return <ComponentsProvider theme={theme}>{children}</ComponentsProvider>;
}

export default EmptyLayout;
